import React from 'react';

export const Input = ({
  value,
  onChange,
  label,
  placeholder,
  helperTextComponent,
  isReadOnly,
  isDisabled,
  isRequired,
  errorMessage,
  inputComponent
}) => {

  return (
      <div className={errorMessage ? "row required" : "row"}>
          <div className="col-25">
              <label>
                  {label}
                  {isRequired && <span className="red-asterisk"> *</span>}
              </label>
              {helperTextComponent}
          </div>
          <div className={isReadOnly ? "readonly col-75" : "col-75"}>
              {inputComponent ? 
                  inputComponent
                  :
                  <input 
                      type="text"
                      value={value} 
                      onChange={(e) => onChange(e.target.value)} 
                      placeholder={placeholder}
                      readOnly={isReadOnly} 
                      disabled={isDisabled}/>
              }
              {/* Error message */}
              {errorMessage && <div className="error-message">*{errorMessage}</div>}
          </div>
          
      </div>
  );
}
